
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypePsvOutlined as ObiVesselTypePsvOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-psv-outlined.js';
 
 
 

 
 export const ObiVesselTypePsvOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-psv-outlined',
   elementClass: ObiVesselTypePsvOutlinedElement,
   events: {
     
   }
  });
 
 